import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/free-regular-svg-icons'

import {
  faUser, 
  faLock, 
  faSignOutAlt, 
  faCog, 
  faBold, 
  faArrowLeft, 
  faUnderline, 
  faStrikethrough, 
  faItalic, 
  faHeading, 
  faTint, 
  faListOl, 
  faListUl, 
  faLink, 
  faUnlink, 
  faImage, 
  faVideo, 
  faTable, 
  faUndo, 
  faRedo, 
  faEdit, 
  faExternalLinkAlt, 
  faQuoteRight, 
  faTextWidth,
  faTextHeight,
  faFont,
  faCompress,
  faExpand,
  faEye,
  faCode,
  faRemoveFormat,
  faMinus,
  faIndent,
  faOutdent,
  faPrint,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faHighlighter,
  faTasks
} from '@fortawesome/free-solid-svg-icons'

import {
  faFileCode,
  faTrashAlt,
  faObjectGroup
} from '@fortawesome/free-regular-svg-icons'

import {
  faGithub
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faUser, 
  faLock, 
  faSignOutAlt, 
  faCog, 
  faGithub, 
  faBold, 
  faArrowLeft, 
  faUnderline, 
  faStrikethrough, 
  faItalic, 
  faHeading, 
  faTint, 
  faListOl, 
  faListUl, 
  faLink, 
  faUnlink, 
  faImage, 
  faVideo, 
  faTable, 
  faFileCode, 
  faUndo, 
  faRedo, 
  faEdit, 
  faExternalLinkAlt, 
  faQuoteRight,
  faTextWidth,
  faTextHeight,
  faFont,
  faCompress,
  faExpand,
  faEye,
  faTrashAlt,
  faCode,
  faRemoveFormat,
  faMinus,
  faIndent,
  faOutdent,
  faPrint,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faHighlighter,
  faTasks,
  faObjectGroup
)

Vue.component('fa', FontAwesomeIcon)
